import { SxProps, Theme } from '@mui/system';

export default {
  create: {
    ':hover': {
      cursor: 'pointer',
    },
  },
} satisfies Record<string, SxProps<Theme>>;
